enum EXPERIMENTS {
  //
  // Localization

  //
  // IST
  onetrust_cookie_banner = 'onetrust_cookie_banner',
  web_identity_server_reset_password = 'web_identity_server_reset_password',

  //
  // Sell
  web_sell_pro_deep_linking = 'web_sell_pro_deep_linking',
  ab_sell_low_demand_badge_web = 'ab_sell_low_demand_badge_web',
  ab_sell_high_competition_badge_web = 'ab_sell_high_competition_badge_web',
  ab_sell_last_sale_badge_web = 'ab_sell_last_sale_badge_web',
  ab_sell_average_sale_price_web = 'ab_sell_average_sale_price_web',
  web_sell_market_shipping_region = 'web_sell_market_shipping_region',
  web_sell_persist_timezone = 'web_sell_persist_timezone',
  web_seller_profile_gtm_banner = 'web_seller_profile_gtm_banner',
  web_seller_bonus_expansion = 'web_seller_bonus_expansion',

  // DRC
  feature_flag_drc_xpress_shipping_web = 'feature_flag_drc_xpress_shipping_web',
  ab_carousel_extend_home_web = 'ab_carousel_extend_home_web',
  ab_home_trending_deals_web = 'ab_home_trending_deals_web',
  feature_flag_market_variable_web = 'feature_flag_market_variable_web',

  // PDP
  'how-it-works-icons-web' = 'how-it-works-icons-web',
  ab_market_data_button_web = 'ab_market_data_button_web',
  ab_recently_viewed_pdp_web = 'ab_recently_viewed_pdp_web',
  ab_follow_improvements_web = 'ab_follow_improvements_web',
  ab_pdp_recently_viewed_anonymous_v2_web = 'ab_pdp_recently_viewed_anonymous_v2_web',
  ab_merchandising_module_pdp_v2_web = 'ab_merchandising_module_pdp_v2_web',
  ab_pdp_sell_button_color_web_1 = 'ab_pdp_sell_button_color_web_1',
  ab_pdp_all_in_bids_asks_tables_web = 'ab_pdp_all_in_bids_asks_tables_web',
  ab_show_indicator_on_non_local_historical_sales_web = 'ab_show_indicator_on_non_local_historical_sales_web',
  ab_pdp_all_in_ify_asks_bids_web = 'ab_pdp_all_in_ify_asks_bids_web',
  ab_pdp_measure_impact_of_360_photo_web = 'ab_pdp_measure_impact_of_360_photo_web',
  ab_pdp_zoom_on_product_photo_v2_web = 'ab_pdp_zoom_on_product_photo_v2_web',

  // Tradebox V5
  ab_pdp_trade_box_v5_web = 'ab_pdp_trade_box_v5_web',

  // Browse 2.0
  browse_2_0_web = 'browse_2_0_web',

  // Search
  ab_search_static_ranking_v3_web = 'ab_search_static_ranking_v3_web',

  // Releases
  feature_flag_releases_page_web = 'feature_flag_releases_page_web',

  // Favorites
  feature_flag_show_favorites_page_web = 'feature_flag_show_favorites_page_web',
  feature_flag_show_favorites_page_web_r2 = 'feature_flag_show_favorites_page_web_r2',

  //
  // Checkout
  ab_pricing_line_items_apple_pay_web = 'ab_pricing_line_items_apple_pay_web',
  ab_riskified_error_web = 'ab_riskified_error_web',
  ab_modify_billing_error_web = 'ab_modify_billing_error_web',
  feature_mexico_rfc_id_web = 'feature_mexico_rfc_id_web',
  portfolio_nft_refactor_web = 'portfolio_nft_refactor_web',
  feature_checkout_xpress_ship_web = 'feature_checkout_xpress_ship_web',
  ab_default_bid_expiration_web = 'ab_default_bid_expiration_web',
  ab_checkout_buying_table_redesign_web = 'ab_checkout_buying_table_redesign_web',
  ab_checkout_buying_page_gql_web = 'ab_checkout_buying_page_gql_web',

  //
  // CS

  //
  // Growth
  notification_settings_global_refactor_web = 'notification_settings_global_refactor_web',
  ab_pirate_payment_reorder_v2_web = 'ab_pirate_payment_reorder_v2_web',
  ab_pirate_product_cell_follow_v2_web = 'ab_pirate_product_cell_follow_v2_web',
  ab_pirate_product_cell_favorite_web_v1 = 'ab_pirate_product_cell_favorite_web_v1',
  product_page_dropx_buy_now_web = 'product_page_dropx_buy_now_web',
  ab_pirate_checkout_bid_guidance_web = 'ab_pirate_checkout_bid_guidance_restart_web',
  ab_pirate_highlight_searchbar_desktop_v4_web = 'ab_pirate_highlight_searchbar_desktop_v4_web',
  ab_pirate_product_page_dlp_crm_v4_web = 'ab_pirate_product_page_dlp_crm_v4_web',
  ab_pirate_product_page_dlp_mdesign_v5_web = 'ab_pirate_product_page_dlp_mdesign_v5_web',
  ab_pirate_product_page_dlp_intl_retest_web = 'ab_pirate_product_page_dlp_intl_retest_web',
  sms_modal_web = 'sms_modal_web',
  sms_modal_promo_header_variations_web = 'sms_modal_promo_header_variations_web',
  profile_page_phone_number_web = 'profile_page_phone_number_web',
  ab_australia_address_locality_label_web = 'ab_australia_address_city_label_web',
  segment_geo_location_web = 'segment_geo_location_web',
  ab_womens_localized_sizes_us_web = 'ab_womens_localized_sizes_us_web',
  text_us_banner_web = 'text_us_banner_web',
  ab_mobile_web_location_selector_web = 'ab_mobile_web_location_selector_web',
  consent_text_creation_web = 'consent_text_creation_web',
  expose_womens_browse_page_meta_web = 'expose_womens_browse_page_meta_web',
  rich_top_of_page_paragraph_enabled_web = 'rich_top_of_page_paragraph_enabled_web',
  ab_pirate_crm_promo_web = 'ab_pirate_crm_promo_web',
  ab_home_add_womens_navigation_web = 'ab_home_add_womens_navigation_web',
  ab_pirate_searchbar_suggestions_web = 'ab_pirate_searchbar_suggestions_web',
  ab_growth_3p_ads_web = 'ab_growth_3p_ads_web',
  ab_size_type_labels_web = 'ab_size_type_labels_web',
  ab_sponsored_rfy_tile_web = 'ab_sponsored_rfy_tile_web',

  // Digital Trading
  nft_position_trading_pdp_web = 'nft_position_trading_pdp_web',
  nft_pdp_breadcrumbs = 'nft_pdp_breadcrumbs',
  web_nft_redeem = 'web_nft_redeem',

  //
  // Payments
  web_enable_MaaS_bid_flow = 'web_enable_MaaS_bid_flow',
  web_enable_MaaS_for_nft = 'web_enable_MaaS_for_nft',
  web_enable_MaaS_vaulting_flow = 'web_enable_MaaS_vaulting_flow',
  enable_paypal_maas_charging_flow_web = 'enable_paypal_maas_charging_flow_web',
  enable_paypal_maas_vaulting_flow_web = 'enable_paypal_maas_vaulting_flow_web',
  ab_enable_paypal_bnpl_web_v2 = 'ab_enable_paypal_bnpl_web_v2',
  web_disable_place_order_click = 'web_disable_place_order_click',
  enable_apm_maas_charging_flow_web = 'enable_apm_maas_charging_flow_web',
  enable_precision_change_gpay_web = 'enable_precision_change_gpay_web',
  web_enable_vault_flip = 'web_enable_vault_flip',

  //
  // Black Friday (Archived)
  // black_friday_2022_web = 'black_friday_2022_web',
  // growth_blackfriday_lp_test_url_web = 'growth_blackfriday_lp_test_url_web',

  //
  // Permanent Flags
  pdp_stats_internal_web = 'pdp_stats_internal_web',
  web_platform_ops_messages = 'web_platform_ops_messages',

  web_platform_tracking_disable_onetrust = 'web_platform_tracking_disable_onetrust',
  web_platform_tracking_disable_ga = 'web_platform_tracking_disable_ga',
  web_platform_tracking_disable_gtm = 'web_platform_tracking_disable_gtm',
  web_platform_tracking_disable_lp = 'web_platform_tracking_disable_lp',

  // System Flags
  web_platform_v4_handle_api = 'web_platform_v4_handle_api',
  web_platform_v4_handle_pages = 'web_platform_v4_handle_pages',
  web_platform_enable_debug_menu = 'web_platform_enable_debug_menu',
}

export default EXPERIMENTS;
